// @flow
import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const compactSx = {
  minHeight: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 16px',
  width: '100%',
  boxSizing: 'border-box',
};

type Props = {
  minHeight?: string,
  compact?: boolean,
};

const PageLoadingFallback = ({ minHeight, compact }: Props) => {
  if (compact) {
    return (
      <Box sx={compactSx} className="page-loading-fallback page-loading-fallback--compact">
        <CircularProgress size={40} />
      </Box>
    );
  }

  const explicitMinHeight = minHeight != null;

  return (
    <Box
      className="page-loading-fallback"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
        width: '100%',
        boxSizing: 'border-box',
        ...(explicitMinHeight
          ? { minHeight }
          : {
              flex: 1,
              minHeight: 0,
              alignSelf: 'stretch',
            }),
      }}
    >
      <CircularProgress size={40} />
    </Box>
  );
};

export default PageLoadingFallback;
